export default "__VITE_ASSET__CSJzFQmF__"